export default function MobileHomeIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <path
        fill="#4e372b"
        d="M448 344v16h-64v32h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
      />
      <path
        fill="#b87a56"
        d="M388 392H44c-11 0-20-9-20-20V150c0-16.6 13.4-30 30-30h324c16.6 0 30 13.4 30 30v222c0 11-9 20-20 20z"
      />
      <path
        fill="#964931"
        d="M388 392H44c-11 0-20-9-20-20v-28h384v28c0 11-9 20-20 20z"
      />
      <circle cx="128" cy="392" r="48" fill="#667441" />
      <circle cx="128" cy="392" r="16" fill="#b87a56" />
      <path
        fill="#4e372b"
        d="M80 448H48c-4.4 0-8-3.6-8-8s3.6-8 8-8h32c4.4 0 8 3.6 8 8s-3.6 8-8 8z"
      />
      <path fill="#98c2c5" d="M24 168h64v80H24zM120 168h96v80h-96z" />
      <path fill="#4e372b" d="M248 168h80v176h-80z" />
      <path fill="#98c2c5" d="M360 168h48v80h-48z" />
      <path
        fill="#964931"
        d="M344 120H88v-9.1C88 98.2 98.2 88 110.9 88h210.2a22.9 22.9 0 0 1 22.9 22.9z"
      />
      <circle cx="464" cy="320" r="32" fill="#964931" />
      <path d="M128 368c-13.2 0-24 10.8-24 24s10.8 24 24 24 24-10.8 24-24-10.8-24-24-24zm0 32c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM80 432H48c-4.4 0-8 3.6-8 8s3.6 8 8 8h32c4.4 0 8-3.6 8-8s-3.6-8-8-8zM120 256h96c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm8-80h80v64h-80z" />
      <path d="M496 320c0-17.6-14.4-32-32-32s-32 14.4-32 32c0 8.2 3.1 15.7 8.2 21.3-.1.9-.2 1.8-.2 2.7v8h-24V150c0-21-17-38-38-38h-26v-1.1c0-17-13.9-30.9-30.9-30.9H110.9C93.9 80 80 93.9 80 110.9v1.1H54c-21 0-38 17-38 38v222c0 15.4 12.6 28 28 28h28.6c3.9 27.1 27.3 48 55.4 48s51.5-20.9 55.4-48H464c13.2 0 24-10.8 24-24v-32c0-.9-.1-1.8-.2-2.7 5.1-5.6 8.2-13.1 8.2-21.3zm-32-16c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm-64-64h-32v-64h32zM96 110.9c0-8.2 6.7-14.9 14.9-14.9h210.2c8.2 0 14.9 6.7 14.9 14.9v1.1H96zM54 128h324c12.1 0 22 9.9 22 22v10h-40c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h40v80h-64V168c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v168H32v-80h56c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8H32v-10c0-12.1 9.9-22 22-22zm202 136h8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8v-72h64v160h-64zM32 176h48v64H32zm0 196v-20h56.9a55.76 55.76 0 0 0-16.3 32H44c-6.6 0-12-5.4-12-12zm96 60c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm256-48H183.4a55.76 55.76 0 0 0-16.3-32H400v20c0 6.6-5.4 12-12 12zm80 0h-50.7c1.7-3.6 2.7-7.7 2.7-12v-4h32c4.4 0 8-3.6 8-8v-9c2.6.7 5.2 1 8 1s5.4-.4 8-1v25c0 4.4-3.6 8-8 8z" />
    </svg>
  );
}
